import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor, getFontWeight } from '../../../../util/theme';

const CtaBarButton = styled.button`
  background-color: ${getColor('accentGreen')};

  border: 3px solid ${getColor('offGreen')};
  outline: 0;

  color: ${getColor('primaryBlue')};
  font-family: 'Roboto', sans-serif;
  font-size: 1.5rem;
  font-weight: ${getFontWeight('medium')};

  display: flex;
  align-items: center;
  justify-content: center;

  margin: 5px 15px;
  padding: 7px;

  cursor: pointer;

  transition: all 0.15s ease-in-out;

  &:hover {
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transform: translateY(-2px);
  }

  &:focus {
    outline: 1px solid ${getColor('white')};
  }

  @media (min-width: ${getBreakpoint('md')}) {
    font-size: 2rem;

    margin: 10px 25px;

    min-width: 300px;
  }

  svg {
    height: 30px;
    width: auto;

    margin: 0 10px 0 0;

    display: block;

    @media (min-width: ${getBreakpoint('md')}) {
      height: auto;
      width: 30px;
    }
  }

  span {
    display: inline-block;

    margin-top: 7px;
  }

  a.tel {
    color: ${getColor('primaryBlue')};
    font-size: 1.5rem;

    &:hover {
      color: ${getColor('white')};
    }

    @media (min-width: ${getBreakpoint('md')}) {
      font-size: 2rem;
    }
  }
`;

export default CtaBarButton;
